import React, { useContext } from "react";
import {
  Button,
  Form,
  FormControl,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { DataContext, UserContext } from "../../App";

import './Header.css';



const Header = () => {
 

 


  const [ signInUser, setSignInUser] = useContext(UserContext);
 

  return (
    <div>
      <Navbar expand="lg">
        <Navbar.Brand href="/home">Book<b style={{color: '#16a738'}}>Garden</b></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto main-navbar">
            <Nav.Link className="nab-item">
              <Link  to="/home">Home</Link>
            </Nav.Link>
            <Nav.Link className="nab-item">
              <Link to="/orders">Orders</Link>
            </Nav.Link>
            <Nav.Link className="nab-item">
              <Link to="/admin">Admin</Link>
            </Nav.Link>
            <Nav.Link className="nab-item">
              <Link to="/deals">Deals</Link>
            </Nav.Link>
            
            <Nav.Link>
           
            {
              signInUser.email ? (<p style={{color:'#28a745'}}>{signInUser.userName}</p> )
                            :<Link to="/login"> <button className="header-btn">Log in</button></Link>
            }

            </Nav.Link>
            
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <spain className="header-spain"></spain>
      
    </div>
  );
};

export default Header;
